const LearningCueModel = {
  created: "date",
  updated: "date",
  fullscreen: "boolean",
  force_pause: "boolean",
}

export default LearningCueModel
